import React, { useState } from "react";
import Styles from "./RATender.module.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ReactComponent as RFPDownloadWhite } from "../../../assets/images/RFPDownloadWhite.svg";
import { ReactComponent as RFPEditWhite } from "../../../assets/images/RFPEditWhite.svg";
import { ReactComponent as RFPDocumentationWhite } from "../../../assets/images/RFPDocumentationWhite.svg";
import { ReactComponent as RFPViewWhite } from "../../../assets/images/RFPViewWhite.svg";
import { ReactComponent as DownloadTenderResWhite } from "../../../assets/images/DownloadTenderResWhite.svg";
import { useDispatch, useSelector } from "react-redux";
import { getTenderState } from "../../../commons/ReverseAuctionStatus";
import Countdown from "../../../commons/CountDownTimer/Countdown";
import {
  getDocument,
  getDocumentTenderRes,
  getequisitionsBidders,
  getequisitionsList,
} from "../../../Services/ReverseAuction/GetApi";
import {
  dateTimeSeperate,
  formatDateTimeViewRfq,
  formatDateType,
} from "../../../commons/FormatDate";
import { ExpandMore } from "@mui/icons-material";
import CreateRfpTender from "../CreateRaTender/CreateRaTender";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal";
import { activeType2Loading } from "../../../Redux/Slices/notificationSlice";
import {
  activateTender,
  approveQuantityRequest,
} from "../../../Services/ReverseAuction/AlterApi";
import { activeTenderId, auctionGet } from "../../../Redux/Slices/auctionSlice";
import RAPlaceBid from "../RAPlaceBid/RAPlaceBid";
import RASelectionModal from "../RASelectionModal/RASelectionModal";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import { SuccessMessage } from "../../../commons/Toast/ErrorMessage";
import { Button, IconButton, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Confirmation from "../Confirmations/Confirmation";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { ReactComponent as UpArrow } from "../../../assets/images/arrowUp.svg";
import { ReactComponent as UpArrowColor } from "../../../assets/images/UpArrowColor.svg";
import { fetchDocumentUrlByLedgerId } from "../../../Redux/Slices/bankingSlice";
import PreviewModal from "../../../commons/PreviewModal/PreviewModal";
import { getDocumentUrlByLedgerId } from "../../../Services/ApiCalling/banking";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import RABidHistory from "../RABidHistory/RABidHistory";

const TenderButtons = (
  role,
  status,
  viewButton,
  canProceedForDocumentation,
  originalTenderCloseDateTime,
) => {
  const location = useLocation();
  const checkIfinitiate =
    new URLSearchParams(location.search).get("type") === "initiate";
  const isCloseDatePassed =
    originalTenderCloseDateTime &&
    new Date(originalTenderCloseDateTime) < new Date();

  // Normalize status - provide default if undefined
  const normalizedStatus = status || "UNKNOWN";

  const buttons = [
    {
      name: "Tender",
      Icon: RFPDownloadWhite,
      key: "download_tender",
      view: true,
    },
    {
      name: "Edit",
      Icon: RFPEditWhite,
      key: "edit_tender",
      view: checkIfinitiate && normalizedStatus === "DRAFT" && viewButton,
    },
    {
      name: isCloseDatePassed ? "View" : "View & Finalize Bids",
      Icon: RFPViewWhite,
      key: "view_bid_tender",
      view:
        checkIfinitiate &&
        normalizedStatus === "BUCKET_FILLED_RA" &&
        viewButton,
    },
    {
      name: "Documentation",
      Icon: RFPDocumentationWhite,
      key: "documentation_tender",
      view:
        normalizedStatus === "TERMS" &&
        (viewButton || !checkIfinitiate) &&
        canProceedForDocumentation,
    },
  ];

  return buttons?.filter((ele) => ele?.view);
};

const RATender = ({ data, expandedTender, handleExpandedTender }) => {
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  const loacation = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const trader = useSelector((state) => state?.persistedReducer);
  const traderParent = trader?.roles?.includes("TRADER");
  const userId = trader?.user?.user?.userId;

  const tenderData = data;
  const viewButton = traderParent
    ? userId === tenderData?.traderAssigned
    : tenderData?.traderAssigned === 0;
  const buttonList = TenderButtons(
    role,
    data?.tenderStatus,
    viewButton,
    tenderData?.canProceedForDocumentation,
    tenderData?.originalTenderCloseDateTime,
  );

  // Ensure Download button is always available
  const finalButtonList =
    buttonList && buttonList.length > 0
      ? buttonList
      : [
          {
            name: "Download Tender",
            Icon: RFPDownloadWhite,
            key: "download_tender",
            view: true,
          },
        ].filter((ele) => ele?.view);
  const tenderTimeDate = {
    tenderNo: tenderData?.tenderNumber,
    tenderStartDateTime: tenderData?.tenderStartDateTime,
    tenderCloseDateTime: tenderData?.tenderCloseDateTime,
    bidStartDateTime: tenderData?.bidStartDateTime,
    bidCloseDateTime: tenderData?.bidCloseDateTime,
    auctionStartDateTime: tenderData?.auctionStartDateTime,
    auctionCloseDateTime: tenderData?.auctionCloseDateTime,
  };
  const status = (tenderData && getTenderState(tenderTimeDate, false)) || "na";

  const [confirmState, setConfirmState] = useState({
    open: false,
    text: "",
    header: "",
    note: "",
  });

  const [reqList, setReqList] = useState(null);
  const [reqLoading, setReqLoading] = useState(false);

  const [createModal, setCreateModal] = useState(false);
  const [editData, setEditData] = useState({});

  const [placeBidModal, setPlaceBidModal] = useState(null);

  const [viewFinalizeModal, setViewFinalizeModal] = useState({
    status: false,
  });
  const [hovered, setHovered] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [previewDocumentId, setPreviewDocumentId] = useState(null);
  const [bidHistory, setBidHistory] = useState({
    open: false,
    tenderId: null,
    requisitionId: null,
  });

  const checkIfinitiate =
    new URLSearchParams(loacation.search).get("type") === "initiate";
  const checkPlaceBid =
    new URLSearchParams(loacation.search).get("type") === "place_bid";

  let tenderStatus =
    status?.includes("ra_ongoing") ||
    status?.includes("tender_closing_soon") ||
    status?.includes("closed")
      ? "AUCTION"
      : "CB";

  const handleReqList = async () => {
    if (expandedTender === tenderData?.tenderNumber) {
      handleExpandedTender("");
      setReqList(null);
      return;
    }
    handleExpandedTender(tenderData?.tenderNumber);
    if (!reqList) {
      setReqLoading(true);
      let res;
      let tenderStatus =
        status?.includes("ra_ongoing") ||
        status?.includes("tender_closing_soon") ||
        status?.includes("closed")
          ? "AUCTION"
          : "CB";
      if (checkIfinitiate) {
        res = await getequisitionsList(tenderData?.id, tenderStatus);
      } else {
        res = await getequisitionsBidders(tenderData?.id, tenderStatus);
      }
      if (res?.data?.code === 200) {
        setReqList(res?.data?.data);
      }
      setReqLoading(false);
    }
  };

  const handleReturnReqDetails = async () => {
    let res = await getequisitionsList(tenderData?.id, "CB");
    return res?.data?.data;
  };

  const handleEdit = async () => {
    const editPayload = {
      id: tenderData?.id,
      capacityId: tenderData?.capacityId,
      requisitions: await handleReturnReqDetails(),
      tenderStartDate: dateTimeSeperate(tenderData?.tenderStartDateTime)?.date,
      tenderEndDate: dateTimeSeperate(tenderData?.tenderCloseDateTime)?.date,
      tenderStartTime: dateTimeSeperate(tenderData?.tenderStartDateTime)?.time,
      tenderEndTime: dateTimeSeperate(tenderData?.tenderCloseDateTime)?.time,
      biddingStartDate: dateTimeSeperate(tenderData?.bidStartDateTime)?.date,
      biddingEndDate: dateTimeSeperate(tenderData?.bidCloseDateTime)?.date,
      biddingStartTime: dateTimeSeperate(tenderData?.bidStartDateTime)?.time,
      biddingEndTime: dateTimeSeperate(tenderData?.bidCloseDateTime)?.time,
      reverseAuctionStartDate: dateTimeSeperate(
        tenderData?.auctionStartDateTime,
      )?.date,
      reverseAuctionEndDate: dateTimeSeperate(tenderData?.auctionCloseDateTime)
        ?.date,
      reverseAuctionStartTime: dateTimeSeperate(
        tenderData?.auctionStartDateTime,
      )?.time,
      reverseAuctionEndTime: dateTimeSeperate(tenderData?.auctionCloseDateTime)
        ?.time,

      initialMargin: tenderData?.initialMarginPercent,
      Emd: tenderData?.emdPerMw,
      minQty: tenderData?.minQtyPerDay,
      paymentSecurity: tenderData?.paymentSecurityDays,
      comment: tenderData?.comments,
      generalTC: tenderData?.tenderDoc,
      auctionType: tenderData?.auctionType,
      auctionParticipants:
        tenderData?.auctionParticipants?.map((p) => p.generatorId) || [],
      comments: tenderData?.comments,
      tenderEntityName: tenderData?.tenderEntityName,
    };
    setEditData(editPayload);
    setTimeout(() => {
      setCreateModal(true);
    }, 2000);
  };

  const handleViewBid = async () => {
    setViewFinalizeModal({
      status: true,
    });
  };

  const handleDownloadTender = async () => {
    const response = await getDocument(tenderData?.id);
    const blob = response.data;
    if (!blob) return;
    const url = window.URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `tender_${tenderData?.id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    SuccessMessage("Tender downloaded successfully!");
  };

  const handleDownloadTenderRes = async () => {
    const response = await getDocumentTenderRes(tenderData?.id);
    const blob = response.data;
    if (!blob) return;
    const url = window.URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `tender_result_${tenderData?.id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    SuccessMessage("Tender Result downloaded successfully!");
  };

  const handleButtonClick = async (type) => {
    if (type === "edit_tender") {
      handleEdit();
    }
    if (type === "view_bid_tender") {
      handleViewBid();
    }

    if (type === "download_tender") {
      handleDownloadTender();
    }

    if (type === "documentation_tender") {
      dispatch(activeTenderId(tenderData?.id));
      localStorage.setItem("activetenderId", tenderData?.id);
      sessionStorage.setItem("lastProductRoute", "/reverse_auction");
      if (checkIfinitiate) {
        navigate(`/tender_active?id=${tenderData?.capacityId}`);
      } else {
        navigate(
          `/tender_active?id=${tenderData?.generatorCapacityId || tenderData?.consumerCapacityId}`,
        );
      }
    }
  };

  const handleActivate = async () => {
    dispatch(activeType2Loading(true));
    setConfirmState((s) => ({ ...s, open: false }));
    const res = await activateTender({}, tenderData?.id);
    if (res?.data?.code === 200) {
      dispatch(auctionGet());
      dispatch(activeType2Loading(false));
    } else {
      dispatch(activeType2Loading(false));
    }
  };

  const handleAcceptRequest = async (id, val) => {
    const payload = { bidIdToStatusMap: { [id]: val } };
    const res = await approveQuantityRequest(payload);
    if (res?.data?.code === 200) {
      window.location.reload();
    }
  };

  const handleViewDocument = async (docId) => {
    if (!docId) {
      console.warn("No document ID provided");
      return;
    }

    try {
      const response = await getDocumentUrlByLedgerId(docId);

      const fileUrl = response?.data;

      if (!fileUrl) {
        console.error("No file URL received");
        return;
      }

      setPreviewFileUrl(fileUrl);
      setPreviewDocumentId(docId);
      setPreviewOpen(true);
    } catch (error) {
      console.error("Error viewing document:", error);
    }
  };

  const handleViewDocumentClick = (e) => {
    e.stopPropagation();

    const docId = data?.tenderDoc;

    if (docId) {
      handleViewDocument(docId);
    }
  };

  const isExpanded = expandedTender === tenderData?.tenderNumber;

  const ReqTableList = ({ ele, index, isOpenForBid }) => {
    return (
      <>
        <div
          className={`display_flex_row tableDetails ${Styles.tableTextElem}`}
        >
          <div style={{ width: "5%" }}>{index + 1}</div>
          <div style={{ width: "20%" }}>
            {" "}
            {`${formatDateType(ele?.dateStartAt)} to`} <br />
            {`${formatDateType(ele?.dateEndAt)}`}
          </div>
          <div style={{ width: "10%" }}>
            {" "}
            {ele?.slotStartAt} to{" "}
            {ele?.slotEndAt === "23:59" ? "24:00" : ele?.slotEndAt}
          </div>
          <div style={{ width: "10%" }}>
            {ele?.requiredQty || ele?.purchaseEnergy || ele?.sellEnergy}
          </div>
          <div style={{ width: "10%" }}>{ele?.minimumQty}</div>
          <div style={{ width: "20%" }}>
            {ele?.lowestBidPrice != null ? ele?.lowestBidPrice : "-"}
          </div>
          {!checkIfinitiate && (
            <>
              <div style={{ width: "10%" }}>
                {ele?.selfBid?.bidQuantityMw || "-"}
              </div>
              <div style={{ width: "10%" }}>
                {ele?.selfBid?.bidPrice || "-"}
              </div>
              {(tenderData?.tenderStatus === "TERMS" ||
                tenderData?.tenderStatus === "BUCKET_FILLED") && (
                <div style={{ width: "10%" }}>
                  {tenderData?.tenderStatus === "TERMS"
                    ? ele?.selfBid?.selectedQuantity
                    : ele?.selfBid?.winnerBidStatus === "PENDING" ||
                        ele?.selfBid?.requestedQuantity
                      ? ele?.selfBid?.requestedQuantity
                      : "-"}
                </div>
              )}
              <div style={{ width: "10%" }}>
                {tenderData?.tenderStatus === "TERMS" ? (
                  <div
                    className={
                      ele?.selfBid?.winnerBidStatus === "AWARDED" ||
                      ele?.selfBid?.winnerBidStatus === "ACCEPTED"
                        ? "accepted"
                        : "rejected"
                    }
                  >
                    {ele?.selfBid?.winnerBidStatus === "AWARDED" ||
                    ele?.selfBid?.winnerBidStatus === "ACCEPTED"
                      ? "Allotted"
                      : ele?.selfBid?.bidQuantityMw
                        ? "Rejected"
                        : "No Bid Placed"}
                  </div>
                ) : tenderData?.tenderStatus === "BUCKET_FILLED" &&
                  ele?.selfBid?.winnerBidStatus === "PENDING" ? (
                  <div className={Styles.bidSelMain}>
                    <div
                      className={Styles.rejectedBid}
                      onClick={() =>
                        handleAcceptRequest(ele?.selfBid?.id, "WITHDRAWN")
                      }
                    >
                      <ClearIcon style={{ fontSize: "10px" }} />
                    </div>
                    <div
                      className={Styles.selectedBids}
                      onClick={() =>
                        handleAcceptRequest(ele?.selfBid?.id, "ACCEPTED")
                      }
                    >
                      <DoneIcon style={{ fontSize: "10px" }} />
                    </div>
                  </div>
                ) : ((tenderData?.tenderStatus === "ACTIVE_BID" &&
                    status.includes("cb_ongoing")) ||
                    (ele?.selfBid?.bidQuantityMw &&
                      tenderData?.tenderStatus === "ACTIVE_RA" &&
                      status.includes("cb_ongoing"))) &&
                  isOpenForBid ? (
                  <div
                    className={`activeButton_type_2 ${Styles.bidButtons}`}
                    onClick={() => setPlaceBidModal(ele)}
                  >
                    {ele?.selfBid?.bidQuantityMw ? "Edit Bid" : "Place Bid"}
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </>
          )}
          {tenderData?.tenderStatus === "TERMS" && (
            <div style={{ width: "10%" }}>
              <VisibilityIcon
                onClick={() =>
                  setBidHistory({
                    open: true,
                    tenderId: tenderData?.id,
                    requisitionId: ele?.id,
                  })
                }
                style={{ fontSize: "16px", color: "var(--primary-color-text)" }}
              />
            </div>
          )}
        </div>
      </>
    );
  };

  const RequisitionTable = () => {
    return (
      <div className={Styles.reqTableMainContainer}>
        <div
          className={`display_flex_row tableHeading ${Styles.tableTextElem}`}
        >
          <div style={{ width: "5%" }}>Requisitions</div>
          <div style={{ width: "20%" }}>Date Range</div>
          <div style={{ width: "10%" }}>Time Range</div>
          <div style={{ width: "10%" }}>Req. Qty (MW)</div>
          <div style={{ width: "10%" }}>Min. Qty (MW)</div>
          <div style={{ width: "20%" }}>Lowest Bid Price (₹/kWh)</div>

          {!checkIfinitiate && (
            <>
              <div style={{ width: "10%" }}>Self Bid Qty (MW)</div>
              <div style={{ width: "10%" }}>Self Bid Price (₹/kWh)</div>

              {(tenderData?.tenderStatus === "TERMS" ||
                tenderData?.tenderStatus === "BUCKET_FILLED") && (
                <div style={{ width: "10%" }}>
                  {tenderData?.tenderStatus === "TERMS"
                    ? "Allocated Qty (MW)"
                    : "Proposed Qty (MW)"}
                </div>
              )}
              <div style={{ width: "10%" }}>
                {tenderData?.tenderStatus === "TERMS" ? "Status" : "Activity"}
              </div>
            </>
          )}
          {tenderData?.tenderStatus === "TERMS" && (
            <div style={{ width: "10%" }}>Bid History</div>
          )}
        </div>
        <div className={`scroll_bar_y ${Styles.reqMainListCont}`}>
          {reqLoading ? (
            <div className={Styles.reqLoader}>Loading...</div>
          ) : (
            reqList?.map((ele, index) => {
              const noBidYet = reqList?.filter((ele) => !ele?.selfBid)?.length;
              const hasCreatedMatch =
                reqList?.filter((ele) => ele?.selfBid?.createdBy === userId)
                  ?.length > 0;
              const isOpenForBid =
                noBidYet === reqList?.length || hasCreatedMatch;
              return (
                <ReqTableList
                  ele={ele}
                  index={index}
                  isOpenForBid={isOpenForBid}
                />
              );
            })
          )}
        </div>
      </div>
    );
  };

  const TenderDetails = () => {
    return (
      <div className={Styles.tenderDetailsMain}>
        <div className={Styles.tenderDetailsMainCont}>
          <div style={{ width: "40%" }} className={Styles.tenderDetail}>
            <div>Tender Process</div>
            <div className={Styles.tenderDateTime}>
              <div className={Styles.tenderDate}>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.tenderStartDateTime,
                    )?.split("-")?.[0]
                  }
                </span>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.tenderStartDateTime,
                    )?.split("-")?.[1]
                  }
                </span>
              </div>
              <div>to</div>
              <div className={Styles.tenderDate}>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.tenderCloseDateTime,
                    )?.split("-")?.[0]
                  }
                </span>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.tenderCloseDateTime,
                    )?.split("-")?.[1]
                  }
                </span>
              </div>
            </div>
          </div>
          <div style={{ width: "40%" }} className={Styles.tenderDetail}>
            <div>IPO Submission</div>
            <div className={Styles.tenderDateTime}>
              <div className={Styles.tenderDate}>
                <span>
                  {
                    formatDateTimeViewRfq(tenderData?.bidStartDateTime)?.split(
                      "-",
                    )?.[0]
                  }
                </span>
                <span>
                  {
                    formatDateTimeViewRfq(tenderData?.bidStartDateTime)?.split(
                      "-",
                    )?.[1]
                  }
                </span>
              </div>
              <div>to</div>
              <div className={Styles.tenderDate}>
                <span>
                  {
                    formatDateTimeViewRfq(tenderData?.bidCloseDateTime)?.split(
                      "-",
                    )?.[0]
                  }
                </span>
                <span>
                  {
                    formatDateTimeViewRfq(tenderData?.bidCloseDateTime)?.split(
                      "-",
                    )?.[1]
                  }
                </span>
              </div>
            </div>
          </div>
          <div style={{ width: "40%" }} className={Styles.tenderDetail}>
            <div>Reverse Auction</div>
            <div className={Styles.tenderDateTime}>
              <div className={Styles.tenderDate}>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.auctionStartDateTime,
                    )?.split("-")?.[0]
                  }
                </span>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.auctionStartDateTime,
                    )?.split("-")?.[1]
                  }
                </span>
              </div>
              <div>to</div>
              <div className={Styles.tenderDate}>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.auctionCloseDateTime,
                    )?.split("-")?.[0]
                  }
                </span>
                <span>
                  {
                    formatDateTimeViewRfq(
                      tenderData?.auctionCloseDateTime,
                    )?.split("-")?.[1]
                  }
                </span>
              </div>
            </div>
          </div>
          <div style={{ width: "20%" }} />
        </div>
        {reqList?.length > 0 && (
          <div
            className={`${Styles.reqTableWrapper} ${isExpanded ? Styles.reqTableExpanded : ""}`}
          >
            {RequisitionTable()}
          </div>
        )}
        <div onClick={handleReqList} className={Styles.viewReqButton}>
          <span>
            {isExpanded && reqList?.length > 0
              ? "Hide Requisitions"
              : "View Requisitions"}
          </span>
          <ExpandMore
            style={{ fontSize: "12px" }}
            className={
              isExpanded && reqList?.length > 0 ? Styles.iconExpanded : ""
            }
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <PdfPreviewModal />
      {viewFinalizeModal?.status && (
        <RASelectionModal
          open={viewFinalizeModal?.status}
          tenderData={tenderData}
          handleClose={() =>
            setViewFinalizeModal({
              status: false,
            })
          }
        />
      )}
      <RABidHistory
        open={bidHistory.open}
        handleClose={() =>
          setBidHistory({ open: false, tenderId: null, requisitionId: null })
        }
        tenderId={bidHistory.tenderId}
        requisitionId={bidHistory.requisitionId}
        showEntityName={true}
        role={role}
      />
      {placeBidModal?.id && (
        <RAPlaceBid
          open={placeBidModal?.id}
          handleClose={() => {
            setPlaceBidModal(null);
          }}
          tenderData={tenderData}
          requisitionData={placeBidModal}
          bidStage={tenderStatus}
          handleUpdate={handleReqList}
          status={status}
          viewBids={true}
          bidBlock={true}
          allRequisitions={reqList}
        />
      )}
      {confirmState.open && (
        <ConfirmationModal
          open={confirmState.open}
          handleClose={() => setConfirmState((s) => ({ ...s, open: false }))}
          data={confirmState.text}
          header={confirmState.header}
          note={confirmState.note}
          handleSubmit={handleActivate}
          type={"ActivateTender"}
        />
      )}
      {createModal && (
        <CreateRfpTender
          open={createModal}
          handleClose={() => {
            setCreateModal(false);
            setEditData(null);
          }}
          duplicate={false}
          editData={editData}
          type={"edit"}
          priceDiscoveryType={"CB"}
        />
      )}
      <PreviewModal
        open={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setPreviewFileUrl(null);
          setPreviewDocumentId(null);
        }}
        fileUrl={previewFileUrl}
        documentId={previewDocumentId}
      />
      <div
        className={`${Styles.eachTenderMainContainer} ${expandedTender === tenderData?.tenderNumber && Styles.activeTenderEachElem}`}
      >
        <div className={Styles.tenderHeaderContainer}>
          <div className={Styles.tenderNoCont}>
            <div>E.Tender Number</div>
            <div>{tenderData?.tenderNumber}</div>
          </div>
          <div className={Styles.tenderNoCont}>
            <div>E.Reverse Auction Number</div>
            <div>{tenderData?.auctionNumber}</div>
          </div>

          <div>
            {data?.tenderStatus === "DRAFT" && viewButton ? (
              <div className={Styles.activateWrapper}>
                <span className={Styles.activateHint}>Publish now &rarr;</span>
                <div
                  className={Styles.activateTender}
                  onClick={() => {
                    setConfirmState({
                      open: true,
                      text: "Do you want to publish this tender?",
                      note: (
                        <>
                          Once published, the tender cannot be edited. Any
                          applicable <b>Activation Fee</b> will be deducted upon
                          publishing.
                        </>
                      ),
                      header: "Publish Tender",
                    });
                  }}
                >
                  Publish Tender
                </div>
              </div>
            ) : (
              <>
                {status && tenderData && (
                  <Countdown
                    status={status}
                    tenderData={tenderData}
                    extended={tenderData?.requisitionAuctionWindow?.length > 0}
                  />
                )}
              </>
            )}
          </div>
        </div>
        {TenderDetails()}
        <div className={Styles.tenderButtonContainer}>
          <div className={Styles.tenderTypeContainer}>
            {data?.tenderEntityName && role === "consumer" && (
              <div className={Styles.tenderNoCont}>
                <div className="pending">Entity Name:</div>
                <div>{data?.tenderEntityName}</div>
              </div>
            )}
            {role === "generator" &&
              checkPlaceBid &&
              data?.productType === "BSRA" && (
                <div className={Styles.tenderNoCont}>
                  <div style={{ color: "var(--primary-color-text)" }}>
                    Buyer :
                  </div>
                  <div>{tenderData?.consumerName}</div>
                </div>
              )}
            {role === "consumer" && checkPlaceBid && (
              <div className={Styles.tenderNoCont}>
                <div style={{ color: "var(--primary-color-text)" }}>
                  Seller :
                </div>
                <div>{tenderData?.generatorName}</div>
              </div>
            )}

            <div className={Styles.tenderNoCont}>
              <div>Tender Type:</div>
              <div>{data?.auctionType}</div>
            </div>

            <div className={Styles.tenderNoCont}>
              <div
                onClick={() => {
                  const tcUrl =
                    "https://otc2-dev.s3.ap-south-1.amazonaws.com/assets/GNA+Energy+-+System+T%26C+-+RFP_RFQ_other.pdf";

                  handlePreviewGeneralTerms(tcUrl, {
                    hideHeader: true,
                  });
                }}
                type="button"
                className={`display_flex_row ${Styles.tandContainer} ${Styles.available_border}`}
              >
                T&C
              </div>
              <span
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ display: "inline-block" }}
              >
                {hovered ? (
                  <UpArrowColor
                    style={{
                      fontSize: "20px",
                      width: "8px",
                      height: "9px",
                      paddingBottom: "8px",
                    }}
                  />
                ) : (
                  <UpArrow
                    style={{
                      fontSize: "20px",
                      width: "8px",
                      height: "9px",
                      paddingBottom: "8px",
                    }}
                  />
                )}
              </span>
            </div>

            {data?.tenderDoc === null ? (
              <></>
            ) : (
              <div className={Styles.tenderNoCont}>
                <div
                  className={`display_flex_row ${Styles.tandContainer} ${Styles.available_border}`}
                  onClick={handleViewDocumentClick}
                  style={{
                    cursor: data?.tenderDoc ? "pointer" : "default",
                    opacity: data?.tenderDoc ? 1 : 0.6,
                  }}
                  title={
                    data?.tenderDoc
                      ? "View Terms & Conditions"
                      : "No T&C document available"
                  }
                >
                  General T&C
                </div>
                <span
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  style={{ display: "inline-block" }}
                >
                  {hovered ? (
                    <UpArrowColor
                      style={{
                        fontSize: "20px",
                        width: "8px",
                        height: "9px",
                        paddingBottom: "8px",
                      }}
                    />
                  ) : (
                    <UpArrow
                      style={{
                        fontSize: "20px",
                        width: "8px",
                        height: "9px",
                        paddingBottom: "8px",
                      }}
                    />
                  )}
                </span>
              </div>
            )}

            {data?.comments !== "" && (
              <div className={Styles.tenderNoCont}>
                <Tooltip title={data?.comments}>
                  <IconButton>
                    <VisibilityIcon
                      style={{
                        cursor: "pointer",
                        height: "16px",
                        width: "16px",
                        color: "var(--primary-color-text)",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <div>Comment</div>
              </div>
            )}
          </div>
          <div className={Styles.buttonContainer}>
            {tenderData?.tenderStatus === "TERMS" && (
              <div
                className={Styles.activeTenderButtons}
                onClick={() => handleDownloadTenderRes()}
              >
                <DownloadTenderResWhite />
                <span>Tender Results</span>
              </div>
            )}
            {finalButtonList?.map((ele) => {
              const Icon = ele.Icon;
              return (
                <div
                  className={Styles.activeTenderButtons}
                  onClick={() => handleButtonClick(ele?.key)}
                >
                  {ele?.key !== "documentation_tender" && <Icon />}
                  <span>{ele?.name}</span>
                  {ele?.key === "documentation_tender" && <Icon />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default RATender;
